import secureLocalStorage from "react-secure-storage";

export enum STORAGE_KEYS {
  OTP = "NIUNhDHp4gTLI8LPHy",
  TOKEN = "maWYWqeCroQXouygqK",
}

const write = (key: STORAGE_KEYS, data: any) => {
  secureLocalStorage.setItem(key, data);
};

const read = <T>(key: STORAGE_KEYS): T | null => {
  return secureLocalStorage.getItem(key) as T;
};

const remove = (key: STORAGE_KEYS) => {
  secureLocalStorage.removeItem(key);
};

export const storage = {
  read,
  write,
  remove,
};
